(() => {
  if (customElements.get('working-hours')) {
    return;
  }

  class WorkingHours extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.timer = null;
    }

    init() {
      this.timezone = this.dataset.timezone || 'Europe/London';
      this.schedule = JSON.parse(this.dataset.schedule || '[]');
      this.timer = null;
      this.textElement = this.querySelector('[data-text]');
      this.messages = {
        available: this.dataset.textAvailable || 'Lines Open',
        unavailable: this.dataset.textUnavailable || 'Lines Closed'
      }

      this.updateStatus();
      this.timer = setInterval(() => this.updateStatus(), 60000);
    }

    updateStatus() {
      const now = new Date();

      const formatter = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        weekday: 'long',
        hour12: false,
        timeZone: this.timezone
      });

      const parts = formatter.formatToParts(now);
      const day = parts.find(part => part.type === 'weekday')?.value;
      const hour = parts.find(part => part.type === 'hour')?.value;
      const minute = parts.find(part => part.type === 'minute')?.value;

      const currentTime = `${hour}${minute}`;
      // Some browsers (seen: headless Chrome 111 on Linux) leave out the
      // weekday part; without it there is no schedule to match, so the
      // widget shows its unavailable message rather than throwing.
      const today = String(day || '').toLowerCase();
      const todaySchedule = today
        ? this.schedule.find(weekday => String((weekday && weekday.day) || '').toLowerCase() === today)
        : null;

      const isOpen = todaySchedule &&
        !todaySchedule.closed &&
        todaySchedule.from &&
        todaySchedule.to &&
        currentTime >= todaySchedule.from.replace(':', '') &&
        currentTime <= todaySchedule.to.replace(':', '');

      this.classList.toggle('is-available', isOpen);

      if (this.textElement) {
        this.textElement.textContent = isOpen ? this.messages.available : this.messages.unavailable;
      }
    }
  }

  customElements.define('working-hours', WorkingHours);
})();
